import Header from '../../../Shared-Component/Header/Header'
import Footer from '../../../Shared-Component/Footer/Footer'
import { useLocation } from 'react-router-dom'
import CampusSlashTitle from '../../CampusSharedComponent/CampusTitles/CampusSlashTitle/CampusSlashTitle'
import CampusDynamicSection from '../../CampusSharedComponent/CampusSections/CampusDynamicSection/CampusDynamicSection'
import playground from "../../../assets/CampuLifeImages/playground.jpg"

const PlayGround = () => {
     const libraryData = {
    img:playground,
    content: "Noorul Islam College of Arts & Science offers a well-maintained playground facility to promote physical well-being and encourage a healthy, active lifestyle among students and staff. The campus includes open fields and designated areas for outdoor sports such as cricket, football, volleyball, and badminton. These spaces provide opportunities for recreation, fitness, and team-building activities, contributing to the overall development of individuals beyond academics. Regular sports events and fitness sessions are organized to engage the campus community and foster a spirit of sportsmanship and camaraderie."
  }
      
  return (
    <>
     <div>
        <Header />
        <div className='campusmaincontainer'>
        <div className='campus-container'>
       <CampusSlashTitle slashTitle="Play ground" />
      <CampusDynamicSection data={libraryData} />
      </div>
      <Footer />
      </div>
      </div>
    </>
  )
}

export default PlayGround